var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7341 11.8444C22.7341 11.0551 22.6464 10.2658 22.5587 9.47656H11.5967V13.9491H17.8231C17.56 15.3522 16.7707 16.6676 15.543 17.4569V20.3509H19.3139C21.5063 18.3339 22.7341 15.3522 22.7341 11.8444Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5981 23.1569C14.7552 23.1569 17.3861 22.1046 19.3154 20.3506L15.5445 17.4567C14.4921 18.1582 13.1767 18.5967 11.5981 18.5967C8.61647 18.5967 5.98559 16.5797 5.10863 13.7734H1.25V16.7551C3.26701 20.7014 7.21333 23.1569 11.5981 23.1569Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1083 13.7745C4.58212 12.3713 4.58212 10.7928 5.1083 9.30198V6.32031H1.24967C-0.416556 9.56507 -0.416556 13.4237 1.24967 16.7561L5.1083 13.7745Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5981 4.56491C13.2644 4.56491 14.8429 5.17879 16.0706 6.31884L19.4031 2.98638C17.2984 1.05707 14.4921 -0.0829779 11.6858 0.00471817C7.30104 0.00471817 3.26702 2.46021 1.33771 6.40653L5.19634 9.3882C5.9856 6.58192 8.61648 4.56491 11.5981 4.56491Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/GOOGLE_PAY.2bcbc3cc309dc140cadf2646cf44b4cb.svg";
export { ForwardRef as ReactComponent };